var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M644,185.4c-5.1-2.6-10-5.5-14.8-8.6c-13.9-9.2-26.6-20-37.9-32.2c-28.3-32.4-38.8-65.2-42.7-88.2h0.2 c-3.2-19.1-1.9-31.4-1.7-31.4H418.3v498.1c0,6.7,0,13.3-0.3,19.8c0,0.8-0.1,1.6-0.1,2.4c0,0.4,0,0.7-0.1,1.1c0,0.1,0,0.2,0,0.3 c-2.8,36.3-23.4,68.8-55,86.8c-16.2,9.2-34.6,14.1-53.3,14.1c-60,0-108.7-48.9-108.7-109.4c0-60.4,48.6-109.4,108.7-109.4 c11.4,0,22.7,1.8,33.5,5.3l0.2-131.2c-66.3-8.6-133.1,11-184.4,53.9c-22.2,19.3-40.9,42.3-55.2,68c-5.4,9.4-26,47-28.4,108.2 c-1.6,34.7,8.9,70.7,13.8,85.5v0.3c3.1,8.8,15.2,38.6,35,63.8c15.9,20.2,34.7,37.9,55.8,52.6v-0.3l0.3,0.3 c62.4,42.4,131.5,39.6,131.5,39.6c12-0.5,52.1,0,97.6-21.6c50.5-23.9,79.2-59.6,79.2-59.6c18.4-21.3,33-45.6,43.2-71.8 c11.7-30.6,15.5-67.4,15.5-82.1V275.8c1.6,0.9,22.4,14.7,22.4,14.7s30,19.2,76.8,31.7C679.8,331.1,725,333,725,333V205.1 C709.2,206.8,677,201.8,644,185.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.22a46a553ef3f9d8f86758b47c7653a2.svg";
export { ForwardRef as ReactComponent };